import { getOneStopProductBySlug } from "./oneStopSolutionContent";

export const publicRoutePatterns = [
  "/",
  "/index",
  "/login",
  "/404",
  "/test",
  "/verify",
  "/Error**",
  "/all**",
  "/prod**",
  "/products/**",
  "/marketing**",
  "/accountDashboard",
  "/about",
  "/contact",
  "/where-to-buy",
  "/warranty",
  "/orderStatus",
  "/MarcoRewards",
  "/newsList",
  "/newsDetail",
  "/help",
  "/shopNow",
] as const;

const removedOneStopListingPaths = ["/apparel", "/equipment", "/gift"] as const;

export const isRemovedOneStopListingRoutePath = (path: string) => {
  const normalizedPath = path.toLowerCase().replace(/\/+$/, "");

  return removedOneStopListingPaths.some(
    (removedPath) => removedPath === normalizedPath || normalizedPath.startsWith(`${removedPath}/`),
  );
};

export const isOneStopProductRoutePath = (path: string) => {
  const normalizedPath = path.toLowerCase().replace(/\/+$/, "");

  if (!normalizedPath.startsWith("/") || normalizedPath.slice(1).includes("/")) {
    return false;
  }

  return getOneStopProductBySlug(normalizedPath.slice(1)) !== null;
};

export const isPublicRoutePath = (path: string, patterns: readonly string[] = publicRoutePatterns) => {
  const currentPath = path.toLowerCase();

  if (isOneStopProductRoutePath(currentPath)) {
    return true;
  }

  return patterns.some((pattern) => {
    const normalizedPattern = pattern.toLowerCase();

    if (normalizedPattern.endsWith("**")) {
      return currentPath.startsWith(normalizedPattern.slice(0, -2));
    }

    return currentPath === normalizedPattern;
  });
};
